var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reset_pw",
    transform: "translate(106 -8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-106 8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cfde929122150d98f45f879fd1f3ec89",
    transform: "translate(-105.439 7016.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 60,
    height: 60,
    rx: 5.494,
    transform: "translate(1.439 1096.636)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "reset",
    transform: "translate(224.439 -7000.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149-2",
    "data-name": "Rectangle 2149",
    width: 32,
    height: 32,
    transform: "translate(-209 8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e44f90cdf47006e0f27e245a97312f81",
    transform: "translate(-208.188 8111.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24628",
    "data-name": "Path 24628",
    d: "M24.119,39.585a.671.671,0,0,0,.949,0l.278-.278V39.7a.671.671,0,0,0,1.343,0v-.393l.278.278a.671.671,0,1,0,.949-.949l-.949-.949.949-.949a.671.671,0,1,0-.949-.949l-.278.278v-.393a.671.671,0,1,0-1.343,0v.393l-.278-.278a.671.671,0,1,0-.949.949l.949.949-.949.949A.671.671,0,0,0,24.119,39.585Zm6.043,0a.671.671,0,0,0,.949,0l.278-.278V39.7a.671.671,0,0,0,1.343,0v-.393l.278.278a.671.671,0,1,0,.949-.949l-.949-.949.949-.949a.671.671,0,1,0-.949-.949l-.278.278v-.393a.671.671,0,1,0-1.343,0v.393l-.278-.278a.671.671,0,1,0-.949.949l.949.949-.949.949A.671.671,0,0,0,30.161,39.585Zm-12.086,0a.671.671,0,0,0,.949,0l.278-.278V39.7a.671.671,0,0,0,1.343,0v-.393l.278.278a.671.671,0,1,0,.949-.949l-.949-.949.949-.949a.671.671,0,1,0-.949-.949l-.278.278v-.393a.671.671,0,0,0-1.343,0v.393l-.278-.278a.671.671,0,1,0-.949.949l.949.949-.949.949A.671.671,0,0,0,18.076,39.585Z",
    transform: "translate(-7.217 -12.843)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24629",
    "data-name": "Path 24629",
    d: "M30.2,22.143H23.486v-9.4A2.689,2.689,0,0,0,20.8,10.057H19.457V6.7a4.705,4.705,0,0,0-4.7-4.7H10.729a4.705,4.705,0,0,0-4.7,4.7v3.357H4.686A2.689,2.689,0,0,0,2,12.743V26.172a2.688,2.688,0,0,0,2.686,2.686h5.371V30.2A1.345,1.345,0,0,0,11.4,31.543H30.2A1.345,1.345,0,0,0,31.543,30.2V23.486A1.345,1.345,0,0,0,30.2,22.143ZM7.371,6.7a3.361,3.361,0,0,1,3.357-3.357h4.029A3.361,3.361,0,0,1,18.114,6.7v3.357H7.371ZM4.686,27.515a1.345,1.345,0,0,1-1.343-1.343V12.743A1.344,1.344,0,0,1,4.686,11.4H20.8a1.344,1.344,0,0,1,1.343,1.343v9.4H11.4a1.345,1.345,0,0,0-1.343,1.343v4.029ZM30.2,30.2H11.4V23.486l18.8,0Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPw);
export default __webpack_public_path__ + "static/media/Reset_pw.70cb3eb5b05bcd73fa594d2122d6654b.svg";
export { ForwardRef as ReactComponent };